import { POLICY_ACTION_TYPES } from '@silverfort-nodelibs/common/utils/consts';

import actionMFAIcon from './Images/mfa.png';
import actionDenyIcon from './Images/deny.png';
import actionAllowIcon from './Images/allow.png';

export const ACTION_TO_ICON = {
    [POLICY_ACTION_TYPES.ALLOW.value]: actionAllowIcon,
    [POLICY_ACTION_TYPES.DENY.value]: actionDenyIcon,
    [POLICY_ACTION_TYPES.MFA.value]: actionMFAIcon,
    [POLICY_ACTION_TYPES.NOTIFY.value]: actionAllowIcon
};

export const POLICY_TYPES = {
    STATIC: { value: 1, label: 'STATIC' },
    RISK_BASED: { value: 2, label: 'RISK BASED' }
};
export const RISK_BY_TYPES = {
    LEVEL: { value: 1, label: 'LEVEL' },
    INDICATORS: { value: 2, label: 'RISK INDICATORS' }
};
